import { message } from 'antd';
import i18next from '../../i18next';

export function whenOrderIsCreated() {
  message.success({
    content: `${i18next.t('deliveries.notifications.whenOrderIsCreated')}`
  });
}

export function whenLocationIsCreated() {
  message.success({
    content: `${i18next.t('modal.addNewLocation.notifications.whenLocationIsCreated')}`
  });
}

export function whenLocationIsFailed(text?: string) {
  return message.error({
    content: `${i18next.t('modal.addNewLocation.notifications.whenLocationIsFailed')}: ${text || ''}`
  });
}

export function whenOrderIsRecreated() {
  message.success({
    content: `${i18next.t('deliveries.notifications.whenOrderIsRecreated')}`
  });
}

export function whenOrderIsQueued() {
  return message.success({
    duration: 5,
    content: `${i18next.t('deliveries.notifications.whenOrderIsQueued')}`
  });
}

export function whenOrderIsFailed(text?: string) {
  return message.error({
    content: `${i18next.t('deliveries.notifications.whenOrderIsFailed')}: ${text || ''}`
  });
}

export function whenOrderIsFailedToRecreate(text?: string) {
  return message.error({
    content: `${i18next.t('deliveries.notifications.whenOrderIsFailedToRecreate')}: ${text || ''}`
  });
}

export function whenOrderIsFailedToCancel(text?: string) {
  return message.error({
    content: `${i18next.t('deliveries.notifications.whenOrderIsFailedToCancel')}: ${text || ''}`
  });
}

export function whenOrderIsCanceled() {
  message.success({
    content: `${i18next.t('deliveries.notifications.whenOrderIsCanceled')}`
  });
}

export function whenCSVDownloadIsFailed() {
  message.error({
    content: `${i18next.t('modal.download.notifications.whenCSVDownloadIsFailed')}`
  });
}

export function noNearbyLocationFound() {
  message.error({
    content: `${i18next.t('deliveries.notifications.noNearbyLocationFound')}`
  });
}

export function reverseGeocodingBlocked() {
  message.error({
    content: `${i18next.t('reverseGeocoding.error.blocked')}`
  });
}
